import React from 'react';
import { Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import FormSpacedLabel from '../../../components/FormSpacedLabel';
import ButtonMulti from '../../../components/Basic/ButtonMulti';
import { useDispatch, useSelector } from 'react-redux';
import { getPnlCalcOptions } from '../../../stores/pnl-chart/getters';
import { updateCalcOptions } from '../../../stores/pnl-chart/actions';

const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.up('md')]: {
      maxWidth: 155,
    },
  },
}));

export const chartTypeTypes = [
  { label: 'Line', value: 'l', longValue: 'LINE' },
  { label: 'candle', value: 'c', longValue: 'CANDLE' },
];

const ChartType = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const chartType = useSelector((state) => {
    const { chartType } = getPnlCalcOptions(state);

    return chartType;
  });

  function handleChange(value) {
    dispatch(updateCalcOptions({ chartType: value }));
  }

  return (
    <Grid item xs={12} md={4} className={classes.root}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <div>
            <FormSpacedLabel>Chart type</FormSpacedLabel>
            <ButtonMulti
              value={chartType}
              options={chartTypeTypes}
              onChange={handleChange}
              name="ChartType"
            />
          </div>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ChartType;
